import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=2656156f&scoped=true"
import script from "./UserForm.ts?vue&type=script&lang=ts&external"
export * from "./UserForm.ts?vue&type=script&lang=ts&external"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=2656156f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656156f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2656156f')) {
      api.createRecord('2656156f', component.options)
    } else {
      api.reload('2656156f', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=2656156f&scoped=true", function () {
      api.rerender('2656156f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/forms/UserForm/UserForm.vue"
export default component.exports